import styled from 'styled-components';
import { Link } from 'react-router-dom';

const BackOption = styled.a`
  position: relative;
  padding: 18px 30px 18px 28px;
  margin-right: 15px;
  color: ${({ theme }) => theme.colors.font};

  &:after {
    position: absolute;
    top: 18px;
    bottom: 18px;
    right: 0;
    border-right: 1px solid ${({ theme }) => theme.borderColor};
    content: '';
  }

  &:hover {
    color: ${({ theme }) => theme.mainColor};
  }

  svg {
    position: absolute;
    top: 20px;
    left: -2px;
  }
`;

export const NavBack = BackOption.withComponent(Link);
